import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-download-success-dialog',
  standalone: true,
  templateUrl: './download-success-dialog.component.html',
  styleUrl: './download-success-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadSuccessDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<DownloadSuccessDialogComponent>);

  close(): void {
    this.dialogRef.close();
  }
}
